export default __webpack_public_path__ + "static/media/search-icon.9a3328c5.svg";